export enum DATA_QA_ATTRIBUTES {
	CONTENT_BLOCKS_SELECTION = 'collaborative-editor-content-blocks-selection',
	EDITOR = 'collaborative-editor',
	TOOLBAR = 'collaborative-editor-toolbar',
	WRAPPER = 'collaborative-editor-wrapper',
}
